module.exports = __webpack_public_path__ + "img/faq_twocolumn.fc67f819.png";